import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Titre from '../UI/Titre.jsx'
import FranceInterRemerciement from '../UI/FranceInter/FranceInterRemerciement.jsx';
import Consent from '../UI/Consent.jsx';
import DonneesPersonnelles from '../UI/DonneesPersonnelles.jsx';
import { useCallback, useState } from 'react';
import { ManageCompteur } from '../Services/ManageCompteur.jsx';
import Accueil from '../UI/Accueil.jsx';
import FranceInterFooter from '../UI/FranceInter/FranceInterFooter.jsx';
import BtnRetour from '../UI/BtnRetour.jsx';
import Temoinage from '../UI/Temoinage.jsx';
import ImageBackground from '../UI/ImageBackground.jsx';
import Description from '../UI/Description.jsx';

function VOC113200({
    interaction,
    afficherAccueil,
    afficherEtapeCollecteParticipation,
    afficherEtapeRemerciement,
    afficherEtapeGRPD,
    afficherEtapeCollectInformationsPersonnelles,
    changerAfficherEtapeCollecteParticipation,
    changerEtapeRemerciement,
    changerEtapeCollecteParticipationVocale,

    setContinueEnabled,
    continueEnabled,

    audioBlob,
    setAudioBlob,
    audioURL,
    setAudioURL,
    sendRecordParticipation,
    sendingParticipationState,

    donneesPersonnelleValid,
    setField,
    userInformation,
    handleRememberMeChange,
    rememberMe,
    canDonneesPersonnelleContinue,
    saveDonneePersonnelle,

    setConsent,
    consentGDPR,
    consentImage,
    passerEtapeRGPDEnabled,
    setMessageErreur,
    retourAccueil,
    passerPageTemoignage,
    changerEtapeCollecteParticipationTexte,
    participation,
}) {

    const {
        counter,
        startCountdownTimer,
        stopCountdownTimer,
        afficherCompteur,
        setAfficherCompteur,
    } = ManageCompteur(interaction);

    const handleStartRecording = useCallback(
        (status) => {
            if (status === 'start') {
                startCountdownTimer();
            }
            if (status === 'stop') {
                stopCountdownTimer();
                setAfficherCompteur(true);
            }
        },
        [setAfficherCompteur, startCountdownTimer, stopCountdownTimer]
    );

    const [afficherEtapeCollecteParticipationImage, setAfficherEtapeCollecteParticipationImage] = useState(true);

    const handleAfficherCompteur = useCallback(
        () => {
            setAfficherCompteur(true);
        }, [setAfficherCompteur]
    );

    const textBTNRetour = "Précédent";

    return (
        <>
            <div class="questionnaire">
                <div className='template-france-inter'>
                    <Titre interaction={interaction} />

                    {afficherAccueil &&
                        // Pas de page d'accueil pour France Inter
                        changerAfficherEtapeCollecteParticipation()
                    }
                    {afficherEtapeCollecteParticipation &&
                        // Page de collecte de participation (limité à 1 vote ou non)
                        <>
                            {afficherEtapeCollecteParticipationImage &&
                                <Row className="home-background text-center">
                                    <Col>
                                        <ImageBackground interaction={interaction} isImageBlur={false} />
                                    </Col>
                                </Row>
                            }
                            {!afficherEtapeCollecteParticipationImage &&
                                <Row className="custom-instructions align-left">
                                    <Col>
                                        <Description interaction={interaction} />
                                    </Col>
                                </Row>
                            }
                            <Temoinage
                                interaction={interaction}
                                audioURL={audioURL}
                                setAudioURL={setAudioURL}
                                audioBlob={audioBlob}
                                setAudioBlob={setAudioBlob}
                                sendRecordParticipation={sendRecordParticipation}
                                maxRecordingTime={interaction.max_recording_time}
                                setContinueEnabled={setContinueEnabled}
                                setMessageErreur={setMessageErreur}
                                sendingParticipationState={sendingParticipationState}
                                participation={participation}
                                changerEtapeCollecteParticipationTexte={changerEtapeCollecteParticipationTexte}
                                changerEtapeCollecteParticipationVocale={changerEtapeCollecteParticipationVocale}
                                retourAccueil={retourAccueil}
                                handleStartRecording={handleStartRecording}
                                counter={counter}
                                afficherCompteur={afficherCompteur}
                                handleAfficherCompteur={handleAfficherCompteur}
                                showPassable={false}
                                showRetour={!afficherEtapeCollecteParticipationImage}
                                setAfficherEtapeCollecteParticipationImage={setAfficherEtapeCollecteParticipationImage}
                                isFranceInter={true}
                                passerPageTemoignage={passerPageTemoignage}
                            />
                        </>
                    }
                    {afficherEtapeCollectInformationsPersonnelles &&
                        <>
                            <DonneesPersonnelles
                                interaction={interaction}
                                setField={setField}
                                userInformation={userInformation}
                                donneesPersonnelleValid={donneesPersonnelleValid}
                                handleRememberMeChange={handleRememberMeChange}
                                rememberMe={rememberMe}
                                canDonneesPersonnelleContinue={canDonneesPersonnelleContinue}
                                saveDonneePersonnelle={saveDonneePersonnelle}
                            />
                            <BtnRetour
                                retourAccueil={retourAccueil}
                                textBTNRetour={textBTNRetour}
                            />
                        </>
                        // Page de collecte de données personnelles
                    }
                    {afficherEtapeGRPD &&
                        <>
                            <Consent
                                customisation={interaction.segment_customisation}
                                consentGDPR={consentGDPR}
                                consentImage={consentImage}
                                setConsent={setConsent}
                            />

                            <div class='d-flex justify-content-evenly fi-rgpd-btn'>
                                <BtnRetour
                                    retourAccueil={retourAccueil}
                                    textBTNRetour={textBTNRetour}
                                />
                                <Row className="custom-commandes">
                                    <Col>
                                        <Button onClick={changerEtapeRemerciement} disabled={!passerEtapeRGPDEnabled} className='continue'>Continuer</Button>
                                    </Col>
                                </Row>

                            </div>
                        </>
                        // Page de consentement
                    }
                    {afficherEtapeRemerciement &&
                        <>
                            <Row className="custom-commandes">
                                <Col>
                                    <FranceInterRemerciement interaction={interaction} >Continuer</FranceInterRemerciement>
                                </Col>
                            </Row>

                        </>
                        // Page de remerciemeent
                    }
                </div>

                <FranceInterFooter />
            </div>
        </>
    )
}
export default VOC113200;
